<template>
    <b-container>
        <h2>Reports</h2>
        <hr>
        <b-list-group class="listItems">
            <b-list-group-item :to="{name: 'reports.Indicators'}">
                Perkins Indicators
            </b-list-group-item>
            <b-list-group-item :to="{name: 'reports.ICRFiles'}">
                Indirect Cost Rate Files
            </b-list-group-item>
            <b-list-group-item :to="{name: 'reports.HistoricalInventoryUploads'}">
                Historical Inventory Uploads
            </b-list-group-item>
            <b-list-group-item :to="{name: 'reports.ExpendituresByCostType'}">
                Expenditures by Cost Type
            </b-list-group-item>
            <b-list-group-item :to="{name: 'reports.ExpendituresByIndicator'}">
                Expenditures by Perkins Indicator
            </b-list-group-item>
            <b-list-group-item :to="{name: 'reports.ExpendituresByCluster'}">
                Expenditures by Career Cluster
            </b-list-group-item>
        </b-list-group>
        <b-list-group v-if="isReviewer" class="listItems">
            <b-list-group-item :to="{name: 'reports.BalanceSheets'}">
                Balance Sheet Reports
            </b-list-group-item>
        </b-list-group>
    </b-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'Reports',

    metaInfo() {
        return { title: 'Reports' };
    },

    data() {
        return {
        };
    },

    computed: {
        ...mapGetters({
            isReviewer: 'auth/isReviewer'
        }),
    },

    created() {
        this.$store.dispatch('ref/ee/fetchRefEe');
    },
};
</script>

<style scoped lang="scss">
.listItems {
    text-align: left;
}
</style>
